import { Box, Button, ButtonGroup, SkeletonText } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import SharedHomeworks from "../../components/homework/SharedHomeworks";
import useGetStudentLearningPaths from "../../hooks/api/learning-path/useGetStudentLearningPaths";
import BasePage from "../common/BasePage";

export default function LearningPathsPage() {
  const { t } = useTranslation();
  const {
    data: learningPaths,
    isLoading,
    isError,
    refetch,
  } = useGetStudentLearningPaths();
  const navigate = useNavigate();

  return (
    <BasePage
      title={t("student_learning_paths_page.your_learning_paths")}
      isLoading={isLoading}
      hasError={isError}
      retry={refetch}
    >
      {isLoading ? (
        <SkeletonText flexGrow={1} skeletonHeight={3} noOfLines={5} />
      ) : (
        <Box bg="red.50" padding={6} mb={12}>
          <ButtonGroup gap="2">
            {/* TODO: Add pagination (?) */}
            {learningPaths?.content?.map(({ id, name }) => (
              <Button
                onClick={() => navigate(`./${id}`)}
                bg="primary.DEFAULT"
                color="white"
                key={id}
              >
                {name}
              </Button>
            ))}
          </ButtonGroup>
        </Box>
      )}
      <SharedHomeworks />
    </BasePage>
  );
}
